var map = {
	"./interview-hero-img-2.webp": 3714,
	"./interview-laptop-any-job.webp": 3719,
	"./interview-laptop-compiler.webp": 3720,
	"./interview-laptop-hr.webp": 3717,
	"./interview-laptop-result-cut.webp": 3721,
	"./interview-laptop-result.webp": 3829,
	"./interview-laptop-technical.webp": 3718,
	"./interview-laptop-web.webp": 3830,
	"./interview-laptop.webp": 3506,
	"./interview-techs-2.webp": 3831,
	"./techs-icons/ds-is-icon-python-scroll.webp": 3722,
	"./techs-icons/ds-is-icon-r-scroll.webp": 3723,
	"./techs-icons/ds-is-icon-sql-scroll.webp": 3724,
	"./techs-icons/python-hero.webp": 3715,
	"./techs-icons/python-talk-is-cheap.webp": 3832,
	"./techs-icons/r-hero.webp": 3716,
	"./techs-icons/r-talk-is-cheap.webp": 3833,
	"./techs-icons/slqlite-talk-is-cheap.webp": 3834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5169;